export default __webpack_public_path__ + "static/media/img-index-01-funcionalidades.90a64148.png";